import { useContext, useState } from "react";
import { DEFAULT_DATA } from "../Constants";
import { AuthContext } from "../../../context/AuthProvider";
import { AppContext } from "../../../context/AppProvider";
import ProductNewEditForm from "../ProductNewEditForm";
import { fetchWithInterceptor } from "../../../utils/fetchWithInterceptor";

const ProductCreateView = ({
  brands,
  categories,
  suppliers,
  unitsOfMeasure,
}) => {
  const [values, setValues] = useState(DEFAULT_DATA);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  const handleDismiss = () => {
    setValues(DEFAULT_DATA);
  };

  const handleSave = async () => {    
    try {
      setIsSubmitting(true);

      const data = new FormData();
      data.append("SKU", values.sku);
      data.append("Name", values.title);
      data.append("Barcode", values.barcode);
      data.append("Status", values.status);
      data.append("CategoryName", values.category);
      data.append("BrandName", values.brand);
      data.append("UnitOfMeasure", values.unitOfMeasure);
      data.append("Tags", values.tags);
      data.append("Description", values.description);
      data.append("SupplierID", values.supplier);
      data.append("SupplierInventoryCode", values.unitsPerCase);
      data.append("ShopifyStatus", values.shopifyStatus);
      data.append("LatestPrice", parseFloat(values.latestPrice || 0));
      data.append("FixedPrice", parseFloat(values.fixedPrice || 0));
      data.append("Weight", values.weight);
      data.append("ContinueSelling", values.continueSelling ? "CONTINUE" : "DENY");
      data.append("Publications", JSON.stringify(values.publications || []));
      data.append("price1", values.price1);
      data.append("price2", values.price2);
      data.append("price3", values.price3);
      data.append(
        "PriceTiers",
        JSON.stringify({
          Tier1: {
            MarkupType: values.markupType1,
            UsePriceType: values.usePriceType1,
            MarkupValue: values.markupValue1,
            Calculated: values.calculated1,
          },
          Tier2: {
            MarkupType: values.markupType2,
            UsePriceType: values.usePriceType2,
            MarkupValue: values.markupValue2,
            Calculated: values.calculated2,
          },
          Tier3: {
            MarkupType: values.markupType3,
            UsePriceType: values.usePriceType3,
            MarkupValue: values.markupValue3,
            Calculated: values.calculated3,
          },
        })
      );
      data.append("Metafields", JSON.stringify(values.metafields || {}));

      if (values.image) {
        data.append("image", values.imageFile);
      }

      const res = await fetchWithInterceptor("/api/products/create", {
        method: "POST",
        headers: {
          "x-access-token": authContext.getToken(),
        },
        body: data,
      });

      if (!res.ok) throw new Error("Error creating product");

      appContext.showMessage("Product created successfully!", "success");
    } catch (err) {
      console.error("Error creating product", err);
      appContext.showMessage("Failed to create product", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ProductNewEditForm
      isEditing={false}
      brands={brands}
      categories={categories}
      suppliers={suppliers}
      unitsOfMeasure={unitsOfMeasure}
      values={values}
      setValues={setValues}
      handleSave={handleSave}
      handleDismiss={handleDismiss}
      isSubmitting={isSubmitting}
    />
  );
};

export default ProductCreateView;
